import React, { useState, useEffect } from 'react';
import { AuthAPI } from '../../axios';

const ImageComponent = ({ cropped_path, index }) => {
  const [imageSrc, setImageSrc] = useState(null);

  useEffect(() => {
    const fetchImage = async () => {
      try {
        const response = await AuthAPI.getImage(`${cropped_path}`);
        setImageSrc(response.image);
      } catch (error) {
        console.error('Error fetching image:', error);
      }
    };

    fetchImage();
  }, [cropped_path]);

  return (
    <img
      src={imageSrc}
      style={{ width: '50px', height: '40px', borderRadius: '10px' }}
      alt={`Waste item ${index}`}
    />
  );
};

export default ImageComponent;
